import React from 'react';
import { connect } from 'react-redux';
import withStyles from '../../core/isomorphic-style-loader/withStyles';
// @ts-expect-error ts-migrate(2307) FIXME: Cannot find module './ToolTip.css' or its correspo... Remove this comment to see the full error message
import s from './ToolTip.css';
import { hideToolTip } from '../../actions/toolTip';
import { isEmptyString } from '../../core/util/string';
import { analyticsTrackEvent } from '../../core/analytics';
import { hideToolTipCookie } from './index';

const mapStateToProps = (state: any) => ({
  toolTip: state.toolTip,
  showArrow: state.showArrow,
});

const mapDispatchToProps = (dispatch: any) => ({
  markToolTipClosed: (name: any) => {
    dispatch(hideToolTip(name));
    hideToolTipCookie(name);
  },
});

const toolTipTimeouts = {};

type OwnToolTipProps = {
  name: string;
  markToolTipClosed?: (...args: any[]) => any;
  hideAfter?: number;
  position?: string;
  showEvent?: string;
  closeEvent?: string;
  closeable?: boolean;
  linkedToolTips?: any[];
  children: React.ReactElement | any[] | string;
  containerClass?: string;
  onClickToHide?: (...args: any[]) => any;
  showArrow?: boolean;
  showUnderlay?: boolean;
  theme?: string;
  toolTip?: any;
};

// @ts-expect-error ts-migrate(2456) FIXME: Type alias 'ToolTipProps' circularly references it... Remove this comment to see the full error message
type ToolTipProps = OwnToolTipProps & typeof ToolTip.defaultProps;

// @ts-expect-error ts-migrate(7022) FIXME: 'ToolTip' implicitly has type 'any' because it doe... Remove this comment to see the full error message
const ToolTip = (props: ToolTipProps) => {
  const isVisible = () => {
    try {
      return props.toolTip[props.name].visible !== false;
    } catch (e) {
      // tooltips default to visible
      return true;
    }
  };

  const handleOnClick = () => {
    if (!props.closeable) {
      return;
    }

    props.markToolTipClosed(props.name);
    if (props.closeEvent) {
      analyticsTrackEvent(props.closeEvent);
    }
  };

  const handleCloseAll = () => {
    if (!props.closeable) {
      return;
    }

    handleOnClick();

    for (const toolTipName of props.linkedToolTips) {
      props.markToolTipClosed(toolTipName);
    }
  };

  const handleOnTimeOut = () => props.markToolTipClosed(props.name);

  if (
    typeof props.hideAfter !== 'undefined' &&
    props.hideAfter > 0 &&
    !toolTipTimeouts.hasOwnProperty(props.name) &&
    isVisible()
  ) {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    toolTipTimeouts[props.name] = setTimeout(handleOnTimeOut, props.hideAfter * 1000);
  }

  const getPositionClass = () => {
    if (isEmptyString(props.position)) {
      return s.center;
    }

    return s[props.position];
  };

  if (isVisible() && props.showEvent) {
    analyticsTrackEvent(props.showEvent);
  }

  if (!isVisible()) {
    return <div />;
  }

  const getToolTipClassName = () => {
    switch (props.theme) {
      case 'blue':
        return s.toolTipBlue;
      case 'dark':
      default:
        return s.toolTip;
    }
  };

  return (
    <div className={getPositionClass()}>
      <div className={props.containerClass}>
        {props.showUnderlay && <div className={s.underlay} onClick={handleCloseAll} />}

        <div className={isVisible() ? s.toolTipContainer : s.toolTipHidden}>
          <div className={getToolTipClassName()}>
            <div
              className={props.closeable ? s.contentCloseable : s.content}
              onClick={handleOnClick}
            >
              {props.children}
            </div>
          </div>

          {props.showArrow && <div className={s.arrow} />}
        </div>
      </div>
    </div>
  );
};

ToolTip.defaultProps = {
  closeable: true,
  linkedToolTips: [],
  showUnderlay: true,
  theme: 'dark',
};

export default withStyles(s)(connect(mapStateToProps, mapDispatchToProps)(ToolTip));
